import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // 基本
        background: '#F4F7F8',
        font_main: '#00020B',
        // メイン見出し
        headline_second: '#00020B',
        // ヘッダー
        header_bg: '#F1F8FE',
        header_font: '#00020B',
        // フッター
        footer_bg: '#E2F0F5',
        footer_link: '#00020B',
        // ボタン
        btn_main_bg: '#7DAECD',
        btn_main_font: '#F1F8FE',
        btn_main_gradation_first: '#1e77d6',
        btn_main_gradation_second: '#06ecfc',
        // 文字サイズ変更ボタン
        change_btn: '#F4F7F8',
        change_btn_invert: '#2a5b79',
        // テキストリンク
        link_main: '#3131D0',
        link_sub: '#F7FF39',
        // 鑑定師一覧・詳細
        actor_box_bg: '#F2F2F2',
        actor_box_font: '#000',
        actor_box_border: '#B2C5FC',
        // メールBOX一覧・鑑定ポイント一覧
        menu_list: '#F2F2F2',
        menu_list_font: '#042324',
        // メールBOX見出し
        mail_box_headline: '#60888B',
        mail_box_headline_font: '#fff',
        // 通知バッジ
        badge: '#CC0909',
        badge_font: '#fff',
        // ポイント表
        table_head: '#60888B',
        table_head_font: '#fff',
        table_body: '#F2F2F2',
        table_body_font: '#60888B',
        // 無料占い結果
        horo_result_bg: '#00279E',
        horo_result_gradation_first: '#327C9D',
        horo_result_gradation_second: '#00279E',
        horo_result_border: '#F4F7F8',
        horo_result_font: '#fff',
        // 強調・注意表示部分
        emphasis: '#AF404D',
        caution: '#AF404D',
        font_annotation: '#fff',
        // その他テキスト
        error: '#AF404D',
        info: '#72bc88',
        success: '#7DAECD',
        // 固定ページ
        page_headline: '#3131D0',
        page_link: '#3131D0'
      }
    },
    options: { customProperties: true }
  }
})
